module.exports = __webpack_public_path__ + "static/media/notification-settings-inactive-vector.544733d6.svg";